module.exports = __webpack_public_path__ + "static/media/Vectoradd.f1b0ca24.svg";